var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		1,
		7
	],
	"./gestione-atti/gestione-atti.module": [
		"./src/app/gestione-atti/gestione-atti.module.ts",
		0,
		2,
		"common",
		4
	],
	"./gestione-fascicoli/gestione-fascicoli.module": [
		"./src/app/gestione-fascicoli/gestione-fascicoli.module.ts",
		0,
		1,
		"common",
		3
	],
	"./gestione-note/gestione-note.module": [
		"./src/app/gestione-note/gestione-note.module.ts",
		0,
		2,
		5
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		6
	],
	"./profilo/profilo.module": [
		"./src/app/profilo/profilo.module.ts",
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;